import { useId, useRef, type FC } from "react";

import { type PropsWithClassName } from "@/components/podkit/lib/cn";

export const VSCodeLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask id={`mask0_${id}`} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.0189 23.8361C17.3969 23.9834 17.8279 23.9739 18.2094 23.7903L23.1506 21.4127C23.6698 21.1629 24 20.6374 24 20.0609V3.93919C24 3.36271 23.6698 2.83723 23.1506 2.58739L18.2094 0.209701C17.7087 -0.0312311 17.1227 0.0277823 16.6832 0.347268C16.6205 0.392906 16.5607 0.443863 16.5046 0.500018L7.04522 9.12996L2.92493 6.0023C2.54136 5.71116 2.00487 5.73502 1.64864 6.05906L0.327127 7.26118C-0.108612 7.65754 -0.109112 8.34305 0.326047 8.74008L3.8993 12L0.326047 15.26C-0.109112 15.657 -0.108612 16.3425 0.327127 16.7389L1.64864 17.941C2.00487 18.265 2.54136 18.2889 2.92493 17.9977L7.04522 14.8701L16.5046 23.5C16.6542 23.6497 16.8299 23.7625 17.0189 23.8361ZM18.0036 6.55174L10.8262 12L18.0036 17.4483V6.55174Z"
                    fill="white"
                />
            </mask>
            <g mask={`url(#mask0_${id})`}>
                <path
                    d="M23.1507 2.59101L18.2057 0.210054C17.6333 -0.0655412 16.9492 0.050711 16.5 0.499924L0.311659 15.2599C-0.123766 15.6569 -0.123266 16.3424 0.312739 16.7388L1.63505 17.9409C1.9915 18.2649 2.52833 18.2888 2.91211 17.9976L22.4066 3.2087C23.0606 2.71255 24 3.17901 24 3.99993V3.94252C24 3.36628 23.6699 2.841 23.1507 2.59101Z"
                    fill="#0065A9"
                />
                <g filter={`url(#filter0_d_${id})`}>
                    <path
                        d="M23.1507 21.4089L18.2057 23.7899C17.6333 24.0655 16.9492 23.9492 16.5 23.5L0.311659 8.74003C-0.123766 8.34302 -0.123266 7.65749 0.312739 7.26113L1.63505 6.05902C1.9915 5.73497 2.52833 5.71111 2.91211 6.00226L22.4066 20.7912C23.0606 21.2874 24 20.8209 24 20V20.0574C24 20.6336 23.6699 21.1589 23.1507 21.4089Z"
                        fill="#007ACC"
                    />
                </g>
                <g filter={`url(#filter1_d_${id})`}>
                    <path
                        d="M18.2059 23.7903C17.6333 24.0658 16.9493 23.9493 16.5 23.5C17.0535 24.0535 18 23.6615 18 22.8787V1.12134C18 0.338523 17.0535 -0.053516 16.5 0.500019C16.9493 0.0507659 17.6333 -0.0656504 18.2059 0.209701L23.1501 2.5874C23.6696 2.83724 24 3.36272 24 3.9392V20.0609C24 20.6374 23.6696 21.1629 23.1501 21.4127L18.2059 23.7903Z"
                        fill="#1F9CF0"
                    />
                </g>
                <g opacity="0.25">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17.0043 23.8362C17.3823 23.9835 17.8133 23.974 18.1948 23.7905L23.136 21.4129C23.6552 21.163 23.9854 20.6375 23.9854 20.061V3.93933C23.9854 3.36282 23.6552 2.83734 23.136 2.5875L18.1948 0.209824C17.6941 -0.0311089 17.1081 0.0279045 16.6686 0.347388C16.6059 0.393029 16.5461 0.443985 16.49 0.500141L7.03063 9.13007L2.91034 6.00244C2.52679 5.71127 1.99028 5.73515 1.63405 6.05918L0.31254 7.26129C-0.1232 7.65767 -0.123699 8.34318 0.31146 8.74019L3.88471 12.0001L0.31146 15.2601C-0.123699 15.6571 -0.1232 16.3426 0.31254 16.739L1.63405 17.9411C1.99028 18.2651 2.52679 18.289 2.91034 17.9979L7.03063 14.8702L16.49 23.5001C16.6396 23.6499 16.8153 23.7626 17.0043 23.8362ZM17.9891 6.55187L10.8116 12.0001L17.9891 17.4484V6.55187Z"
                        fill={`url(#paint0_linear_${id})`}
                    />
                </g>
            </g>
            <defs>
                <filter
                    id={`filter0_d_${id}`}
                    x="-8.34793"
                    y="-2.53439"
                    width="40.6813"
                    height="34.8056"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="4.16667" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow_9768_3799" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9768_3799" result="shape" />
                </filter>
                <filter
                    id={`filter1_d_${id}`}
                    x="8.16666"
                    y="-8.27145"
                    width="24.1667"
                    height="40.543"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="4.16667" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="overlay" in2="BackgroundImageFix" result="effect1_dropShadow_9768_3799" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9768_3799" result="shape" />
                </filter>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="11.9854"
                    y1="0.0620116"
                    x2="11.9854"
                    y2="23.9383"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
